export const TRACK_ERROR_SOURCES = {
    ASSET_LOADING_FAILED: 'Client',
    UPC_NOT_AVAILABLE: 'Product',
    VALIDATION_FAILED: 'Client',
};
export const TRACK_EVENTS_CODES = {
    explosion: 'Events_RTRExplosion',
    // panning: 'Events_RTRPanning',
    rotation: 'Events_RTRRotation',
    zoom: 'Events_RTRZoom',
};
